import $ from 'jquery';
import processInclude from './util';
import appointments from './appointments/appointments';

$(document).ready(() => {
  processInclude(appointments);
});
